export const getAvailabilityOptions = async () => {
    const availabilityOptions = [
        {
            label: "Available",
            id: "Available"
        }, {
            label: "Out of Office",
            id: "Out of Office"
        }
    ]
    return availabilityOptions;
}

// Roles an actor of `level` may grant — at or below their own tier (anti-escalation). Previously
// this was inconsistent (e.g. a disclosureAdmin got ONLY "Super Admin", and a responder oddly got
// "School Admin"), which — combined with a hardcoded caller — meant admins could barely assign roles
// (GH #130). The backend (roles.canGrantRole, FEAT-044) remains the authoritative gate; this only
// drives the UI options. NOTE: custom per-tenant roles (Roles page) are still assigned there, not
// here — wiring roleIds into this surface is the remaining FEAT-044 follow-up (#124/#130).
const ROLE_LABELS = {
    responder: "Responder",
    schoolAdmin: "School Admin",
    districtAdmin: "District Admin",
    disclosureAdmin: "Super Admin",
};

const GRANTABLE_BY_LEVEL = {
    disclosureAdmin: ["responder", "schoolAdmin", "districtAdmin", "disclosureAdmin"],
    districtAdmin: ["responder", "schoolAdmin", "districtAdmin"],
    schoolAdmin: ["responder", "schoolAdmin"],
    responder: [],
};

export const getPermissionOptions = async (level) => {
    const grantable = GRANTABLE_BY_LEVEL[level] || [];
    return grantable.map((value) => ({ label: ROLE_LABELS[value], value }));
}
